module.exports = __webpack_public_path__ + "static/7-bc1e47a3976358aa868a72de5a85de5a.woff";